import * as React from "react";
import { connect } from "react-redux";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilPersistence } from "../../utils/utilPersistence";
import { utilVersion } from "../../utils/utilVersion";
import { GameUrlByStatus } from "../client-gateway/epicClientGateway";
import { IdStatusClientGateway } from "../client-gateway/IdStatusClientGateway";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { BaseButton } from "../generic/base-button/BaseButton";
import { IdButtonType } from "../generic/base-button/IdButtonType";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { actionEnvSelect } from "./actionEnvSelect";
var _DialogEnvSelect = function (_a) {
    var onSelect = _a.onSelect;
    var clearUserTestCredentials = function () {
        utilPersistence.setValue(IdPersistence.TestCredentials, {}, PersistenceMode.Write);
        utilPersistence.setValue(IdPersistence.Tutorial, {}, PersistenceMode.Reset);
    };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.empty, className: "dialog" },
        React.createElement("div", { className: "flex flex--aligned flex--around flex--stacked w100 h100" },
            React.createElement("div", { className: IdStyles.TextBoldAccent }, "Please select your environment to connect"),
            React.createElement("div", { className: "flex flex--stacked flex--aligned" },
                React.createElement(ButtonPrimary, { onClick: function () { return onSelect(IdStatusClientGateway.Integration); } },
                    React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault }, "Integration")),
                React.createElement("div", { className: IdStyles.TextNormal },
                    "Server: ",
                    GameUrlByStatus.get(IdStatusClientGateway.Integration))),
            React.createElement("div", { className: "flex flex--stacked flex--aligned" },
                React.createElement(ButtonSecondary, { onClick: function () { return onSelect(IdStatusClientGateway.Approval); } },
                    React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault }, "Staging")),
                React.createElement("div", { className: IdStyles.TextNormal },
                    "Server: ",
                    GameUrlByStatus.get(IdStatusClientGateway.Approval))),
            React.createElement("div", { className: "flex flex--stacked flex--aligned" },
                React.createElement(ButtonSecondary, { onClick: function () { return onSelect(IdStatusClientGateway.HotFix); } },
                    React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault }, "HotFix")),
                React.createElement("div", { className: IdStyles.TextNormal },
                    "Server: ",
                    GameUrlByStatus.get(IdStatusClientGateway.HotFix))),
            React.createElement(BaseButton, { name: IdStyles.ButtonSpecial, styleId: IdButtonType.ButtonRectangleExtraLarge, onClick: function () { return clearUserTestCredentials(); } },
                React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault }, "Clear Credentials"))),
        React.createElement("div", null,
            React.createElement("p", { className: IdStyles.TextNormal },
                "Version: ",
                utilVersion.getCurrentVersion()))));
};
var mapDispatch = function (dispatch) { return ({
    onSelect: function (env) { return dispatch(actionEnvSelect(env)); },
}); };
export var DialogEnvSelect = connect(undefined, mapDispatch)(_DialogEnvSelect);



//////////////////
// WEBPACK FOOTER
// ./src/features/env-select/DialogEnvSelect.tsx
// module id = 2821
// module chunks = 3